<template>
  <nav v-if="totalPages > 1" class="hub-pagination" dir="ltr">
    <button
      type="button"
      class="page-btn"
      :class="{ 'is-disabled': isFirst }"
      :disabled="isFirst"
      :aria-label="$t('HUB.FB_POSTS.PAGINATION.FIRST')"
      @click="go(1)"
    >
      <span class="dbl-chevron">
        <fluent-icon icon="chevron-left" size="12" />
        <fluent-icon icon="chevron-left" size="12" />
      </span>
    </button>
    <button
      type="button"
      class="page-btn"
      :class="{ 'is-disabled': isFirst }"
      :disabled="isFirst"
      :aria-label="$t('HUB.FB_POSTS.PAGINATION.PREV')"
      @click="go(currentPage - 1)"
    >
      <fluent-icon icon="chevron-left" size="16" />
    </button>

    <template v-for="(item, index) in pages">
      <span v-if="item === '...'" :key="`dots-${index}`" class="page-dots">
        …
      </span>
      <button
        v-else
        :key="`page-${item}`"
        type="button"
        class="page-btn page-num"
        :class="{ 'is-active': item === currentPage }"
        @click="go(item)"
      >
        {{ item }}
      </button>
    </template>

    <button
      type="button"
      class="page-btn"
      :class="{ 'is-disabled': isLast }"
      :disabled="isLast"
      :aria-label="$t('HUB.FB_POSTS.PAGINATION.NEXT')"
      @click="go(currentPage + 1)"
    >
      <fluent-icon icon="chevron-right" size="16" />
    </button>
    <button
      type="button"
      class="page-btn"
      :class="{ 'is-disabled': isLast }"
      :disabled="isLast"
      :aria-label="$t('HUB.FB_POSTS.PAGINATION.LAST')"
      @click="go(totalPages)"
    >
      <span class="dbl-chevron">
        <fluent-icon icon="chevron-right" size="12" />
        <fluent-icon icon="chevron-right" size="12" />
      </span>
    </button>
  </nav>
</template>

<script>
export default {
  props: {
    currentPage: {
      type: Number,
      default: 1,
    },
    totalPages: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    isFirst() {
      return this.currentPage <= 1;
    },
    isLast() {
      return this.currentPage >= this.totalPages;
    },
    // First + last page always shown, a window of ±1 around the current page,
    // with '...' filling the gaps.
    pages() {
      const total = this.totalPages;
      const current = this.currentPage;
      const left = Math.max(2, current - 1);
      const right = Math.min(total - 1, current + 1);
      const result = [1];
      if (left > 2) result.push('...');
      for (let i = left; i <= right; i += 1) result.push(i);
      if (right < total - 1) result.push('...');
      if (total > 1) result.push(total);
      return result;
    },
  },
  methods: {
    go(page) {
      const target = Math.min(Math.max(page, 1), this.totalPages);
      if (target !== this.currentPage) this.$emit('page-change', target);
    },
  },
};
</script>

<style scoped>
.hub-pagination {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-family: 'Open Sans', sans-serif;
}
.page-btn {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  height: 32px;
  padding: 0 8px;
  border: none;
  border-radius: 8px;
  background: #ffffff;
  outline: 1px solid #f5f5f5;
  outline-offset: -1px;
  color: #6b7280;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition:
    outline-color 0.15s,
    background 0.15s,
    color 0.15s;
}
.page-num {
  color: #525252;
}
.page-btn:hover:not(.is-active):not(.is-disabled) {
  outline-color: #4bce97;
  color: #216e4e;
}
.page-btn.is-active {
  background: #2abb7f;
  outline-color: #2abb7f;
  color: #ffffff;
  pointer-events: none;
}
.page-btn.is-disabled {
  background: #f5f5f5;
  outline-color: #f5f5f5;
  color: #a3a3a3;
  cursor: not-allowed;
}
.page-dots {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  height: 32px;
  color: #525252;
  font-size: 13px;
  font-weight: 600;
}
.dbl-chevron {
  display: inline-flex;
  align-items: center;
}
.dbl-chevron > :last-child {
  margin-inline-start: -7px;
}
</style>
